import {FC} from 'react'

import {Button, ButtonStatus} from '@/components/common/content/Button'
import {ButtonVariant} from '@/components/common/content/ButtonTypes'
import {ArrowIcon} from '@/components/common/icons/ArrowIcon'
import {theme} from '@/theme/theme'

import {FormErrorMessage} from './FormErrorMessage'

type FormButtonProps = {
  text: string
  onClick?: () => void
  type?: 'submit' | 'button'
  isInactive?: boolean
  isDisabled?: boolean
  dataTest?: string
  status?: ButtonStatus
  hasIcon?: boolean
  submitError?: string | null
  marginTop?: string
}

export const FormButton: FC<FormButtonProps> = ({
  text,
  onClick,
  type,
  isInactive,
  isDisabled,
  dataTest,
  status,
  hasIcon = true,
  submitError,
  marginTop = theme.spacing[7],
}) => {
  const textColor = isInactive ? theme.palette.text.disabled : theme.palette.text.white

  return (
    <>
      <div className="button-wrapper">
        {submitError && (
          <FormErrorMessage message={submitError} marginBottom={theme.spacing[1.5]} />
        )}
        <Button
          type={type}
          data-test={dataTest}
          variant={ButtonVariant.primary}
          fullWidth
          isInactive={isInactive}
          disabled={isInactive || isDisabled}
          textColor={textColor}
          icon={hasIcon ? <ArrowIcon color={textColor} /> : undefined}
          onClick={onClick}
          isIconAnimated={hasIcon}
          status={status}
        >
          {text}
        </Button>
      </div>

      <style jsx>{`
        .button-wrapper {
          margin-top: ${marginTop};
        }
      `}</style>
    </>
  )
}
